import React from 'react';
import styled from 'styled-components';
import FilterSelectionItem from './FilterSelectionItem';
import ClearFilters from './ClearFilters';
import Tabs from '../../interfaces/Tabs';
import {InventoryState} from 'features/Inventories/reducer/InventoryReducer';

const StyledDropDownContainer = styled.div`
  display: flex;
  gap: 16px;
  &.hide-geo-filter .filter-geo {
    display: none;
  }
`;

interface FiltersProps {
  selectedTab: Tabs;
  invState: InventoryState;
  handleFilterChange: (value: string[], category: string) => void;
  handleClearFilters: () => void;
  isDisabled: boolean;
}

function Filters({
  invState,
  selectedTab,
  handleFilterChange,
  handleClearFilters,
  isDisabled,
}: FiltersProps) {
  const isGeoTabSelected = selectedTab !== Tabs.CUSTOM ? 'hide-geo-filter' : '';

  return (
    <StyledDropDownContainer className={`${isGeoTabSelected}`}>
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'brand'}
        category="brand"
        label={'Brand'}
        selectedValues={invState.filterParams.brand}
        options={invState.filters.brand}
        handleFilterChange={handleFilterChange}
        className={`filter-brand`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'geo'}
        category="geo"
        label={'Geo'}
        selectedValues={invState.filterParams.geo}
        options={invState.filters.geo}
        handleFilterChange={handleFilterChange}
        className={`filter-geo`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'siteType'}
        category="siteType"
        label={'Site Type'}
        selectedValues={invState.filterParams.siteType}
        options={invState.filters.siteType}
        handleFilterChange={handleFilterChange}
        className={`filter-siteType`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'nvsnso'}
        category="nvsnso"
        label={'NVS/NSO'}
        selectedValues={invState.filterParams.nvsnso}
        options={invState.filters.nvsnso}
        handleFilterChange={handleFilterChange}
        className={`filter-siteType`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'storeConcept'}
        category="storeConcept"
        label={'Concept'}
        selectedValues={invState.filterParams.storeConcept}
        options={invState.filters.storeConcept}
        handleFilterChange={handleFilterChange}
        className={`filter-concept`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'siteStatus'}
        category="siteStatus"
        label={'Site Status'}
        selectedValues={invState.filterParams.siteStatus}
        options={invState.filters.siteStatus}
        handleFilterChange={handleFilterChange}
        className={`filter-status`}
      />
      <FilterSelectionItem
        isDisabled={isDisabled}
        key={'deviceType'}
        category="deviceType"
        label={'Device Type'}
        selectedValues={invState.filterParams.deviceType}
        options={invState.filters.deviceType}
        handleFilterChange={handleFilterChange}
        className={`filter-deviceType`}
      />
      <ClearFilters handleClearFilters={handleClearFilters} />
    </StyledDropDownContainer>
  );
}

export default Filters;
